import styled from 'styled-components';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

export const PillLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(45.01deg, #00d7d7 23.29%, #84f11e 88.12%);
  color: ${homeColor.ink};
  padding: 13px 25px;
  border-radius: 999px;
  font-family: ${getToken('font-family-default')};
  font-size: 14px;
  font-weight: 700;
  box-shadow: 0 8px 28px rgba(20, 214, 77, 0.3);
  transition:
    transform 0.15s,
    box-shadow 0.2s;
  cursor: pointer;
  border: none;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 12px 34px rgba(20, 214, 77, 0.42);
  }
`;

export const GhostLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid ${homeColor.line2};
  color: ${homeColor.white};
  padding: 13px 22px;
  border-radius: 999px;
  font-family: ${getToken('font-family-default')};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: rgba(20, 214, 77, 0.07);
  }
`;
